<template>
    <!-- <section class="about_section">

        <div class="about_container">
            <div class="about_box_title">
                <h1 class="about_title text_align_left">
                    Заголовок заголовок
                </h1>
                <h2 class="about_title text_align_right">
                    заголовок заголовок
                </h2>
            </div>
            <p class="about_subtitle">
                Подзаголовок подзаголовок подзаголовок подзаголовок<br />
                Подзаголовок подзаголовок подзаголовок подзаголовок подза
            </p>
        </div>
        <div class="about_element_elepse"></div>
        <img
            src="@/assets/elements/Ellipse_2.svg"
            class="about_element_elepse_2"
            alt="Ellipse 2"
        />
    </section> -->
    <section class="section_main_pages">
        <div class="blur_main_pages">
            <video
                class="img_bg_video"
                loop
                autoplay
                playsinline
                disablePictureInPicture
                muted
                poster="/video/hero-poster.jpg"
                preload="auto"
            >
                <source
                    src="/video/hero.webm"
                    type="video/webm"
                />
                <source
                    src="/video/hero.mp4"
                    type="video/mp4"
                />
            </video>
        </div>
        <img
            src="@/assets/elements/Shkurenko.png"
            class="img_Shkurenko"
        />
        <div
            class="box_phone"
            @click="showPhoneMenu = true"
        >
            <img
                class="phone"
                src="@/assets/elements/phone.png"
            />
        </div>
        <div
            class="box_phone_animation"
            :class="{ active: showPhoneMenu }"
        >
            <div class="container_contacts_header">
                <img
                    src="@/assets/elements/cross.png"
                    class="cross"
                    @click="showPhoneMenu = false"
                />
                <div
                    class="box_contacts_header"
                    @click="copyPhone"
                >
                    <p class="text_contacts_header">Для клиентов</p>
                    <div class="contacts_header">
                        <a
                            href="tel:+79136603997"
                            class="text_contacts_header"
                        >
                            +7 913 660-39-97
                        </a>
                        <div class="copying_clients"></div>
                        <div class="copying_text">Скопировано</div>
                    </div>
                </div>
                <div
                    class="box_contacts_header"
                    @click="copyPhone"
                >
                    <p class="text_contacts_header">Для соискателей</p>
                    <div class="contacts_header">
                        <a
                            href="tel:+79509539292"
                            class="text_contacts_header"
                        >
                            +7 950 953-92-92
                        </a>
                        <div class="copying_clients"></div>
                        <div class="copying_text">Скопировано</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutSection',
    data () {
        return {
            showModal: false,
            showContacts: false,
            showPhoneMenu: false,
        };
    },
    methods: {
        copyPhone (event) {
            const contactsHeader = event.currentTarget.querySelector('.contacts_header');

            if (!contactsHeader) return;

            const phoneElement = contactsHeader.querySelector('a');
            const textEl = contactsHeader.querySelector('.copying_text');

            const phone = phoneElement?.innerText?.trim();

            if (phone && textEl) {
                navigator.clipboard.writeText(phone).then(() => {
                    textEl.style.display = 'block';
                    setTimeout(() => {
                        textEl.style.display = 'none';
                    }, 3000);
                });
            }
        },

    },
};
</script>

<style scoped>
.section_main_pages {
    width: 100%;
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.blur_main_pages {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(60, 33, 24, 0.5);
    pointer-events: none;
}
.img_bg_video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    position: absolute;
    pointer-events: none;
}
.img_Shkurenko {
    width: 40.6rem;
    height: 4.26rem;
    z-index: 2;
}
.box_phone {
    display: none;
}
.box_phone_animation{
    display: none;
}
@media (max-width: 767px) {
    .img_Shkurenko {
        width: 15.85rem;
        height: 1.65rem;
        z-index: 2;
    }
    .box_phone {
        display: flex;
        width: 3.44rem;
height: 3.44rem;
        box-shadow: 0.35rem 0.5rem 0.91rem -0.45rem rgba(38, 29, 29, 0.6);
        background: rgb(245, 245, 245);
        position: absolute;
        bottom: 1.8rem;
        right: 1.8rem;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
    }
    .phone {
        width: 1.94rem;
height: 1.75rem;
    }
    .box_phone_animation{
    display: flex;
    backdrop-filter: blur(1.25rem);
background: rgba(25, 25, 25, 0.7);
padding: 2rem;
position: absolute;
width: 100%;
bottom: -10rem;
left: 0px;
right: 0px;
transition: 0.2s ease;
}
.text_contacts_header{
    color: rgb(245, 245, 245);
font-family: Montserrat_SemiBold;
font-size: 0.7rem;
font-weight: 700;
line-height: 0.7rem;
}
.copying_clients{
    width: 0.45rem;
height: 0.55rem;
    background-image: url(/src/assets/elements/copying.png);
    background-position: 50%;
    background-repeat: no-repeat;
    transition: 0.2s ease;
    background-size: contain;
}
.copying_text {
    position: absolute;
   bottom: -1.5rem;
    right: 0;
    font-family: Montserrat_SemiBold;
font-size: 0.7rem;
font-weight: 700;
line-height: 0.7rem;
    color: #fff;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.6rem;
    white-space: nowrap;
    display: none;
    z-index: 100;
    border: 0.1rem solid rgb(220, 102, 64);
    z-index: 1;
}
.contacts_header{
    display: flex;
    gap: 0.3rem;
    align-items: center;
}
.box_contacts_header{
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    cursor: pointer;
    position: relative;
    cursor: pointer;
    width: fit-content;
}
.container_contacts_header {
position: relative;
    transition: 0.2s ease;
    display: flex;
    gap: 2rem;
    flex-direction: column;
    width: 100%;
}
.cross{
    position: absolute;
    width: 0.91rem;
height: 0.91rem;
top: 0px;
right: 0px;
}
.box_phone_animation.active {
  bottom: 0;
  transition: 0.2s ease;
}
}
</style>
